"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarDividerStyles_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarDividerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdivider = require("@fluentui/react-divider");
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "ftuwxu6",
        B2u0y6b: "f1lwjmbk",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1oic3e7"
    },
    vertical: {
        B2u0y6b: "fe668z"
    }
}, {
    d: [
        ".ftuwxu6{display:inline-flex;}",
        ".f1lwjmbk{max-width:1px;}",
        [
            ".f1oic3e7{padding:0 12px;}",
            {
                p: -1
            }
        ],
        ".fe668z{max-width:initial;}"
    ]
});
const useToolbarDividerStyles_unstable = (state)=>{
    'use no memo';
    (0, _reactdivider.useDividerStyles_unstable)(state);
    const { vertical } = state;
    const toolbarDividerStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(toolbarDividerStyles.root, !vertical && toolbarDividerStyles.vertical, state.root.className);
    return state;
};
